const initial_state = {
    count: 0
};

const REDUCE_STATE = {
    COUNT: "COUNT",
};

export { initial_state, REDUCE_STATE };
